import { render, staticRenderFns } from "./UiFormDialog.vue?vue&type=template&id=3a211c36&scoped=true"
import script from "./UiFormDialog.vue?vue&type=script&lang=js"
export * from "./UiFormDialog.vue?vue&type=script&lang=js"
import style0 from "./UiFormDialog.vue?vue&type=style&index=0&id=3a211c36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a211c36",
  null
  
)

export default component.exports